enum AuthFactor {
  PUSH = 'PUSH',
  SMS = 'SMS',
  RECOVERY_CODE = 'RECOVERY_CODE',
}

type RecoveryCode = {
  id: number
  raw: string
}

export { AuthFactor, type RecoveryCode }
